import * as yup from 'yup';

yup.setLocale({
  mixed: {
    default: 'Valor inválido',
    required: 'Campo obrigatório',
    notNull: 'Este campo não pode ser nulo',
    defined: 'Este campo deve ser preenchido',
    notType: 'Tipo de dado inválido',
  },
  string: {
    email: 'E-mail inválido',
    length: 'Preencher exatamente ${length} caracteres',
    min: 'Preencher ao menos ${min} caracteres',
    max: 'Preencher no máximo ${max} caracteres',
  },
  array: {
    min: 'Adicionar ao menos ${min} item',
  },
});

yup.addMethod(yup.string, 'validateFullName', function (message) {
  const defaultMessage = 'Informe nome e sobrenome válidos.';
  return this.test('full-name-validation', message || defaultMessage, function (value) {
    if (!value) return false;
    const parts = value.trim().split(/\s+/);
    if (parts.length < 2) {
      return false;
    }
    return parts[0].length > 2 && parts[1].length > 1;
  });
});

declare module 'yup' {
  interface StringSchema {
    validateFullName(message?: string): StringSchema;
  }
}

export default yup;
